/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { CompilerImpl as ɵCompilerImpl } from './compiler_factory';
export { platformCoreDynamic as ɵplatformCoreDynamic } from './platform_core_dynamic';
export { INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS as ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS } from './platform_providers';
export { ResourceLoaderImpl as ɵResourceLoaderImpl } from './resource_loader/resource_loader_impl';
//# sourceMappingURL=private_export.js.map